export default {
  name: 'gmk-olivia',
  override: {
    KC_SPC: 'accent',
    KC_ENT: 'accent',
    KC_ESC: 'accent',
    KC_F1: 'key',
    KC_F2: 'key',
    KC_F3: 'key',
    KC_F4: 'key',
    KC_F9: 'key',
    KC_F10: 'key',
    KC_F11: 'key',
    KC_F12: 'key',
    KC_LEFT: 'accent',
    KC_RGHT: 'accent',
    KC_DOWN: 'accent',
    KC_UP: 'accent'
  }
};
